import React from 'react';

const ColorPickerSVG = ({ color, className, onClick, ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='40'
      height='40'
      viewBox='0 0 40 40'
      fill='none'
    >
      <g
        clipPath='url(#paint0_angular_1292_105116_clip_path)'
        dataFigmaSkipParse='true'
      >
        <g transform='matrix(0 0.02 -0.02 0 20 20)'>
          <foreignObject x='-1050' y='-1050' width='2100' height='2100'>
            <div
              xmlns='http://www.w3.org/1999/xhtml'
              style={{
                background:
                  'conic-gradient(from 90deg,rgba(151, 71, 255, 1) 0deg,rgba(108, 0, 250, 1) 51.9231deg,rgba(22, 115, 255, 1) 109.038deg,rgba(23, 221, 49, 1) 159.231deg,rgba(204, 239, 65, 1) 197.308deg,rgba(251, 255, 37, 1) 238.846deg,rgba(251, 169, 10, 1) 270deg,rgba(246, 77, 42, 1) 304.615deg,rgba(151, 71, 255, 1) 360deg);height:100%;width:100%;opacity:1',
              }}
            ></div>
          </foreignObject>
        </g>
      </g>
      <circle
        cx='20'
        cy='20'
        r='20'
        dataFigmaGradientFill='{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":0.59215688705444336,"g":0.27843138575553894,"b":1.0,"a":1.0},"position":0.0},{"color":{"r":0.42483660578727722,"g":0.0,"b":0.98039215803146362,"a":1.0},"position":0.14423076808452606},{"color":{"r":0.086274512112140656,"g":0.45176470279693604,"b":1.0,"a":1.0},"position":0.30288460850715637},{"color":{"r":0.090823061764240265,"g":0.86996692419052124,"b":0.19470891356468201,"a":1.0},"position":0.44230768084526062},{"color":{"r":0.80320429801940918,"g":0.93973481655120850,"b":0.25708228349685669,"a":1.0},"position":0.54807692766189575},{"color":{"r":0.98568969964981079,"g":1.0,"b":0.14853140711784363,"a":1.0},"position":0.66346156597137451},{"color":{"r":0.98431372642517090,"g":0.66274511814117432,"b":0.039215687662363052,"a":1.0},"position":0.750},{"color":{"r":0.96470588445663452,"g":0.30196079611778259,"b":0.16470588743686676,"a":1.0},"position":0.84615385532379150}],"stopsVar":[{"color":{"r":0.59215688705444336,"g":0.27843138575553894,"b":1.0,"a":1.0},"position":0.0},{"color":{"r":0.42483660578727722,"g":0.0,"b":0.98039215803146362,"a":1.0},"position":0.14423076808452606},{"color":{"r":0.086274512112140656,"g":0.45176470279693604,"b":1.0,"a":1.0},"position":0.30288460850715637},{"color":{"r":0.090823061764240265,"g":0.86996692419052124,"b":0.19470891356468201,"a":1.0},"position":0.44230768084526062},{"color":{"r":0.80320429801940918,"g":0.93973481655120850,"b":0.25708228349685669,"a":1.0},"position":0.54807692766189575},{"color":{"r":0.98568969964981079,"g":1.0,"b":0.14853140711784363,"a":1.0},"position":0.66346156597137451},{"color":{"r":0.98431372642517090,"g":0.66274511814117432,"b":0.039215687662363052,"a":1.0},"position":0.750},{"color":{"r":0.96470588445663452,"g":0.30196079611778259,"b":0.16470588743686676,"a":1.0},"position":0.84615385532379150}],"transform":{"m00":2.4492935992912173e-15,"m01":-40.0,"m02":40.0,"m10":40.0,"m11":2.4492935992912173e-15,"m12":-2.4492935992912173e-15},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
      />
      <defs>
        <clipPath id='paint0_angular_1292_105116_clip_path'>
          <circle cx='20' cy='20' r='20' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ColorPickerSVG;
